import Entity from "./entity";
import {eventPollGet, eventPollAnswerClick, eventPollOpenAnswers, eventPollRatingAnswers} from "./api";
import wordcloud from "./cloud";

const MAX_ANSWER_LENGTH = 600;

export default function($app) {
	const $comet = $app.require('comet');
	const $auth = $app.require('auth');
	const $locale = $app.require('locale');

	const polls = this._polls = ko.observableArray([]);

	this.forceShow = ko.observable(false);
	this.polls = ko.computed(() => {
		if (this.forceShow()) {
			const poll = polls()
				.sort((a, b) => a.id() - b.id())
				.filter(poll => !poll.isVoted())
				[0]
			;
			return poll ? [poll] : [];
		}
		if (!$app.currentStream()) return [];
		const streamId = $app.currentStream().id();

		let filteredPolls = polls()
			.filter(poll => poll.streamId() === streamId)
			.filter(poll => poll.isResult() || (poll.isActive() && (!poll.isVoted() || !poll.private())))
			.filter(poll => poll.isShow())
		;

		// if ($auth.client()?.info()?.city) {
		// 	const clientCity = $auth.client()?.info()?.city.toLowerCase().trim();
		// 	filteredPolls = filteredPolls
		// 		.filter(poll => 'rating' !== poll.type() || poll.object().toLowerCase().trim() !== clientCity)
		// 	;
		// }

		return filteredPolls;
	});

	this.openPollResult = ko.observable(null);
	this.polls.subscribe(polls => {
		setTimeout(() => {
			this.openPollResult(polls.find(poll => poll.isOpen() && poll.isResult()) || null);
		}, 0);
	});

	this.openPollResult.subscribe(poll => {
		setTimeout(() => {
			if (null === poll) {
				return;
			}

			if (0 === poll.answer().length) {
				return;
			}

			const list = poll.answer()
				.map(answer => {
					return [answer.textRu(), answer.count()];
				})
			;
			wordcloud.cloud(
				list,
				{
					colors: poll.options()?.answerColors || [],
				});
		}, 0);
	});

	this.submitOpenAnswers = (form) => {
		const data = new FormData(form);
		const poll = this.polls().find(poll => poll.id() === intval(data.get('pollId')));

		if (!$auth.isLoggedIn() && poll.authorizationRequired() && !$auth.isAuthDisabled()) {
			poll.isShow(false);
			$auth.login('Для участия в опросе, вам необходимо авторизоваться')
				.finally(() => poll.isShow(true));

			return false;
		}

		let $form = $(form);
		const answers = $form.serializeArray()
			.filter(item => item.name === 'answers[]')
			.map(item => item.value.trim())
			.filter(item => item)
		;

		if (answers.length === 0) {
			alert($locale.get('poll.alert.emptyAnswer'));
			return;
		}

		for (let i = 0; i < answers.length; i++) {
			if (answers[i].length > MAX_ANSWER_LENGTH) {
				alert($locale.get('poll.alert.longAnswer'));
				return;
			}
		}

		let $submitBtn = $form.find('input[type="submit"]');

		$submitBtn
			.attr('disabled', true)
		;

		eventPollOpenAnswers($app.event().eventKey(), data)
			.then(() => {
				poll.vote();
				$form.find('input').attr('disabled', true);
				$submitBtn.val($locale.get('poll.answer.click.success'));
			})
		;
	};

	this.vote = (poll) => {
		if (!poll.validateAnswer()) {
			return Promise.reject();
		}

		const authRequired = poll.authorizationRequired() && !$auth.isAuthDisabled();
		if (!$auth.isLoggedIn() && authRequired) {
			poll.isShow(false);
			$auth.login('Для участия в опросе, вам необходимо авторизоваться')
				.finally(() => poll.isShow(true))
			;

			return Promise.reject();
		}

		if (poll.isRating()) {
			return eventPollRatingAnswers(
				$app.event().eventKey(),
				poll.id(),
				poll.answerData()
			).then(() => {
				poll.vote();
			});
		}

		if (poll.isStandard()) {
			const answerIds = [];
			poll.answer().forEach(answer => {
				if (answer.isSelected()) {
					answerIds.push(answer.id())
				}
			});

			if (!answerIds) {
				return Promise.reject();
			}

			return eventPollAnswerClick(
					$app.event().eventKey(),
					poll.id(),
					answerIds,
					authRequired
				)
				.then(() => poll.vote())
			;
		}
	};

	this.multipleSelectAnswer = (answer) => {
		const poll = answer.poll();
		if (poll.isVoted()) {
			return;
		}

		answer.toggleSelect();
	}

	this.selectAnswer = (answer) => {
		const poll = answer.poll();
		if (!poll.isVoted()) {
			answer.select();
			const onSuccess = () => {
				if (poll.private()) {
					alert($app.require('locale').get('poll.answer.click.success'));
				}
			};

			this.vote(poll)
				.then(onSuccess)
				.catch(() => answer.unselect())
			;
		}
	};

	this.hidePoll = () => {
		this.polls().forEach(poll => poll.isShow(false));
	};

	const fixData = (data, type) => {
		const map = ({
			poll: {event_id: 'eventId', stream_id: 'streamId'},
			answer: {event_id: 'eventId', stream_id: 'streamId', poll_id: 'pollId'}
		})[type];
		Object.keys(map).forEach(from => {
			const to = map[from];

			if(data[from] && !data[to]) {
				data[to] = data[from];
			}
		});
		return data;
	};

    const updatePoll = (data) => {
        data = fixData(data, 'poll');
        const poll = polls().find(p => p.id() === data.id);
        if(poll) {
            poll.fillFrom(data);
        } else {
            polls.push(new Entity.Poll(data));
        }

        if (data.answer instanceof Array) {
            data.answer.forEach(answer => updatePollAnswer(answer));
        }
    };
    const removePoll = (id) => {
        polls.remove((poll) => poll.id() === id);
    };

    const updatePollAnswer = (data) => {
        data = fixData(data, 'answer');
        const poll = polls().find(p => p.id() === data.pollId);
        if(!poll) {
            return;
        }

        const answer = poll.answer().find(a => a.id() === data.id);
        if (answer) {
            answer.fillFrom(data);
        } else {
            poll.answer.push(new Entity.Poll.Answer(data, poll));
        }
    };
    const removePollAnswer = (id) => {
        const poll = polls().find(p => p.id() === data.pollId);
        if(poll) {
            return;
        }

        poll.answer.remove(answer => answer.id() === id);
    };

	$app.on('start', () => {
		eventPollGet($app.event().eventKey())
			.then(data => {
				polls(data.map(poll => new Entity.Poll(fixData(poll, 'poll'))));
			});

		$comet
			.on('create:poll', updatePoll)
			.on('update:poll', updatePoll)
			.on('delete:poll', ({id}) => removePoll(id))
			.on('create:poll/answer', updatePollAnswer)
			.on('update:poll/answer', updatePollAnswer)
			.on('delete:poll/answer', ({id}) => removePollAnswer(id))
		;
	});

};
